// Primary Navigation
//
// - Mobile menu: a <dialog>, opened as a modal below the desktop
//   breakpoint, and shown inline (never opened) from it
// - Dropdowns: <details> sharing a `name`, so only one is open at a time
// - Escape, clicking outside or focus leaving the nav closes everything
//
// uses:
// - Alpine.js
// - @alpinejs/focus
//
// Params (optional):
// - desktopQuery: media query from which the menu is shown inline,
//   eg: x-data="primaryNav({ desktopQuery: '(min-width: 56.25em)' })"

(function () {
  // Matches the sm breakpoint (56.25em / 900px)
  const SM_MEDIAQUERY = '(min-width: 56.25em)';

  document.addEventListener('alpine:init', () => {
    Alpine.data('primaryNav', (params = {}) => ({
      // Config
      desktopQuery: params.desktopQuery || SM_MEDIAQUERY,

      // State
      isMobileMenuOpen: false,

      // Actions

      // Close any open dropdown
      closeDropdowns() {
        this.$root.querySelectorAll('details[open]').forEach((details) => {
          details.open = false;
        });
      },

      openMobileMenu() {
        this.closeDropdowns();
        this.$refs.menu.showModal();
        this.isMobileMenuOpen = true;
      },

      closeMobileMenu() {
        this.closeDropdowns();
        this.$refs.menu.close();
        this.isMobileMenuOpen = false;
      },

      toggleMobileMenu() {
        if (this.isMobileMenuOpen) {
          this.closeMobileMenu();
        } else {
          this.openMobileMenu();
        }
      },

      // Close everything
      closeAll() {
        this.closeMobileMenu();
      },

      // Alpine init
      init() {
        // Reset everything when crossing into desktop
        var desktop = window.matchMedia(this.desktopQuery);
        desktop.addEventListener('change', (e) => {
          if (e.matches) {
            this.closeAll();
          }
        });
      },

      // Bindings
      rootHandler: {
        ['x-on:keydown.escape.window']() {
          this.closeAll();
        },
        ['x-on:click.outside']() {
          this.closeAll();
        },
        // Close when keyboard focus moves out of the nav
        ['x-on:focusin.window'](event) {
          if (!this.$root.contains(event.target)) {
            this.closeAll();
          }
        },
      },

      mobileMenuTriggerHandler: {
        ['x-bind:aria-expanded']() {
          return this.isMobileMenuOpen;
        },
        ['x-on:click']() {
          this.toggleMobileMenu();
        },
      },

      mobileMenuCloseHandler: {
        ['x-on:click']() {
          this.closeMobileMenu();
        },
      },

      mobileMenuHandler: {
        ['x-trap.noscroll']() {
          return this.isMobileMenuOpen;
        },
        // Sync state when the browser closes it (eg: on Escape)
        ['x-on:close']() {
          this.closeDropdowns();
          this.isMobileMenuOpen = false;
        },
      },
    }));
  });
})();
